module.exports = __webpack_public_path__ + "static/korred-d4b793fbed371c53465b1ae58253b4c3.jpeg";